// Import necessary modules from React and other libraries
import React, { useState } from "react";
import Link from "next/link";
import "react-tabs/style/react-tabs.css";
import Meta from "../../components/Meta";
import Image from "next/image";
//import Logo from "./../../public/logo/black.png";

import WhiteIconLogo from "./../../public/images/Ico-LOGO/white.png";
import WhiteLogo from "./../../public/logo/only-text-logo.png";
import eyefill from '../../public/eye-fill.svg';
import eyeclose from '../../public/eye-slash-fill.svg';


// import { IconButton } from '@mui/material';
// import { BiLeftArrowAlt } from 'react-icons/bi';
import { useDispatch } from 'react-redux';
// import { Input } from '../../global/components/Custom';
// import FormLeftSide from '../../global/components/FormLeftSide';
// import LoginWithFacebook from '../../global/components/LoginWithFacebook';
import { userRegister } from '../../redux/user/actionCreator';
import { errorToast } from '../../utils/toast';
import {
  validateEmail,
  validateName,
  validatePassword,
  validatePhone,
  validateUserName,
} from '../../utils/validation';
// import './Registration.css';
// import walletImg from '../../assets/wallet.png';
import BasicModal from '../../utils/modal';
import AgeVarify from '../../utils/AgeVarify';
import { useRouter } from 'next/router';
import LoginWithGoogle from "../../components/LoginWithGoogle";

const SignUp = () => {
  const dispatch = useDispatch();
  //const navigate = useNavigate();
  const [open, setOpen] = useState(false)
  const [showPassword, setShowPassword] = useState({
    password: false,
    confirmPassword: false,
  });
  const router = useRouter();

  const [data, setData] = useState({
    email: {
      value: '',
      error: '',
    },
    firstName: {
      value: '',
      error: '',
    },
    lastName: {
      value: '',
      error: '',
    },
    phone: {
      value: '',
      error: '',
    },
    password: {
      value: '',
      error: '',
    },
    confirmPassword: {
      value: '',
      error: '',
    },
    username: {
      value: '',
      error: '',
    },
    termsAndConditions: {
      value: false,
      error: '',
    },

    recaptchaToken: null,
    provider: 'email',
  });
  const handleClose = () => setOpen(false);

  const handleOpen = (e) => {
    e.preventDefault();

    if (
      (validateEmail(data.email.value) || validatePhone(data.phone.value)) &&
      validatePassword(data.password.value) &&
      validatePassword(data.confirmPassword.value) &&
      data.password.value === data.confirmPassword.value &&
      validateUserName(data.username.value) &&
      validateName(data.lastName.value) &&
      validateName(data.firstName.value) &&
      data.termsAndConditions.value == true
    ) {
      // alert("valid");
      setOpen(true)
    } else {
      setData((prev) => ({
        ...prev,
        email: {
          ...prev.email,
          error:
            prev.provider === 'email'
              ? validateEmail(prev.email.value)
                ? ''
                : 'Invalid Email format'
              : '',
        },
        phone: {
          ...prev.phone,
          error:
            prev.provider === 'phone'
              ? validatePhone(prev.phone.value)
                ? ''
                : 'Invalid phone format'
              : '',
        },
        password: {
          ...prev.password,
          error: validatePassword(prev.password.value)
            ? ''
            : 'Password should be minimum of 8 characters long',
        },
        confirmPassword: {
          ...prev.confirmPassword,
          error:
            prev.password.value === prev.confirmPassword.value
              ? ''
              : 'Password should be same',
        },
        username: {
          ...prev.username,
          error: validateUserName(prev.username.value)
            ? ''
            : 'Invalid username',
        },
        firstName: {
          ...prev.firstName,
          error: validateUserName(prev.firstName.value)
            ? ''
            : 'Invalid first name',
        },
        lastName: {
          ...prev.lastName,
          error: validateUserName(prev.lastName.value)
            ? ''
            : 'Invalid last name',
        },
        termsAndConditions: {
          ...prev.termsAndConditions,
          error:
            prev.termsAndConditions.value == true
              ? ''
              : 'Please select terms and conditions',
        },
      }));
    }
  };
function navigate(arg)
{
  router.push(arg);
}
  const onRegistrationHandler = () => {
    if (
      (validateEmail(data.email.value) || validatePhone(data.phone.value)) &&
      validatePassword(data.password.value) &&
      validatePassword(data.confirmPassword.value) &&
      data.password.value === data.confirmPassword.value &&
      validateUserName(data.username.value) &&
      validateName(data.lastName.value) &&
      validateName(data.firstName.value) &&
      data.termsAndConditions.value == true
    ) {
      const value = {
        email: data.email.value,
        phone: data.phone.value,
        password: data.password.value,
        confirmPassword: data.confirmPassword.value,
        username: data.username.value,
        lastName: data.lastName.value,
        firstName: data.firstName.value,
        recaptchaToken: data.recaptchaToken,
        provider: data.provider,
      };
      if (data.provider === 'email') {
        dispatch(userRegister(value,navigate));
      } else {
        if (data.recaptchaToken != null) {
          dispatch(userRegister(value, navigate));
        } else {
          errorToast('Select the Recaptcha token');
        }
      }
    } else {
      setData((prev) => ({
        ...prev,
        email: {
          ...prev.email,
          error:
            prev.provider === 'email'
              ? validateEmail(prev.email.value)
                ? ''
                : 'Invalid Email format'
              : '',
        },
        phone: {
          ...prev.phone,
          error:
            prev.provider === 'phone'
              ? validatePhone(prev.phone.value)
                ? ''
                : 'Invalid phone format'
              : '',
        },
        password: {
          ...prev.password,
          error: validatePassword(prev.password.value)
            ? ''
            : 'Password should be minimum of 8 characters long',
        },
        confirmPassword: {
          ...prev.confirmPassword,
          error:
            prev.password.value === prev.confirmPassword.value
              ? ''
              : 'Password should be same',
        },
        username: {
          ...prev.username,
          error: validateUserName(prev.username.value)
            ? ''
            : 'Invalid username',
        },
        firstName: {
          ...prev.firstName,
          error: validateUserName(prev.firstName.value)
            ? ''
            : 'Invalid first name',
        },
        lastName: {
          ...prev.lastName,
          error: validateUserName(prev.lastName.value)
            ? ''
            : 'Invalid last name',
        },
        termsAndConditions: {
          ...prev.username,
          error:
            prev.termsAndConditions.value == true
              ? ''
              : 'Please select terms and conditions',
        },
      }));
    }
  };
  return (
    <div>
      <Meta title="SignUp || Impactoverse " />
      {/* <!-- SignUp --> */}
      <section className="relative">
        <div className="lg:flex lg:h-full">
          {/* <!-- Left --> */}

          <div className="relative text-center lg:w-1/2">
            <Image
              width={768}
              height={722}
              src="/images/login.jpg"
              alt="login"
              className="absolute h-full w-full object-cover"
            />
            {/* <!-- Logo --> */}
            <div className="relative inline-block py-36 px-5">
              <Link href="/" className="relative">
                <div>
                  <Image
                    src={WhiteIconLogo}
                    height={42}
                    width={195}
                    className="mx-auto flex top-0 z-10 bg-blue-500 rounded-md animate-spin-faux3d"
                    alt="Impactoverse | Impact Ecosystem"
                  />
                </div>
              </Link>
              <Link href="/" className="relative ">
                <div>
                  <Image
                    src={WhiteLogo}
                    height={100}
                    width={400}
                    className="mx-auto flex top-0 z-10 bg-blue-500 rounded-md animate-spin-faux3d"
                    alt="Impactoverse | Impact Ecosystem"
                  />
                </div>
              </Link>
            </div>
          </div>

          {/* <!-- Right --> */}
          <div className="relative flex items-center justify-center p-[10%] lg:w-1/2">
            <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
              <Image
                width={1519}
                height={900}
                priority
                src="/images/gradient_light.jpg"
                alt="gradient"
                className="h-full w-full object-cover"
              />
            </picture>

            <div className="w-full max-w-[25.625rem] text-center">
              <h2 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase pb-0 mb-0">
                SIGN UP
              </h2>
              <p className="text-lg dark:text-jacarta-300 mb-6 leading-normal">
                Already have account?
                <Link href="/sign-in" className="text-accent">
                  {" "}
                  SIGN IN
                </Link>
              </p>
              <form id="contact-form" method="post">
                <div className="flex space-x-7">
                  <div className="mb-4 w-1/2">
                    <label className="mb-1 flex items-center space-x-2 dark:text-jacarta-200 text-sm text-left uppercase">
                      First Name<span className="text-red">*</span>
                    </label>
                    <input
                      name="firstName"
                      className="contact-form-input dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white"
                      id="firstName"
                      type="text"
                      required
                      onChange={(e) => {
                        setData({
                          ...data,
                          firstName: {
                            value: e.target.value,
                            error: validateName(e.target.value)
                              ? ''
                              : 'Invalid first name',
                          },
                        });
                      }}
                      inputValue={data.firstName}
                    />
                    <div className=" text-left w-full text-red  ">{data.firstName.error}</div>
                  </div>

                  <div className="mb-4 w-1/2">
                    <label className="mb-1 flex items-center space-x-2 dark:text-jacarta-200 text-sm text-left uppercase">
                      Last Name<span className="text-red">*</span>
                    </label>
                    <input
                      name="lastName"
                      className="contact-form-input dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white"
                      id="lastName"
                      type="text"
                      required
                      onChange={(e) => {
                        setData({
                          ...data,
                          lastName: {
                            value: e.target.value,
                            error: validateName(e.target.value)
                              ? ''
                              : 'Invalid last name',
                          },
                        });
                      }}
                      inputValue={data.lastName}
                    />
                    <div className=" text-left w-full text-red  ">{data.lastName.error}</div>

                  </div>
                </div>
                <div className="mb-4">
                  <label className="mb-1 flex items-center space-x-2 dark:text-jacarta-200 text-sm text-left uppercase">
                    Username<span className="text-red">*</span>
                  </label>
                  <input
                    id="username"
                    className="contact-form-input dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white"
                    required
                    name="username"
                    type="text"
                    onChange={(e) => {
                      setData({
                        ...data,
                        username: {
                          value: e.target.value,
                          error: validateUserName(e.target.value)
                            ? ''
                            : 'Invalid username',
                        },
                      });
                    }}
                    inputValue={data.username}
                  />
                  <div className=" text-left w-full text-red  ">{data.username.error}</div>

                </div>
                <div className="mb-4">
                  <label className="mb-1 flex items-center space-x-2 dark:text-jacarta-200 text-sm text-left uppercase">
                    Email<span className="text-red">*</span>
                  </label>
                  <input
                    id="email"
                    className="contact-form-input dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white"
                    required
                    name="email"
                    type="email"
                    onChange={(e) => {
                      setData({
                        ...data,
                        email: {
                          value: e.target.value,
                          error: validateEmail(e.target.value)
                            ? ''
                            : 'Invalid email format',
                        },
                      });
                    }}
                    inputValue={data.email}
                    disabled={data.provider !== 'email'}
                  />
                  <div className=" text-left w-full text-red  ">{data.email.error}</div>
                </div>
                <div className="flex space-x-7">
                  <div className="mb-4 w-1/2">
                    <label className="mb-1 flex items-center space-x-2 dark:text-jacarta-200 text-sm text-left uppercase">
                      Password<span className="text-red">*</span>
                    </label>
                    <div className=" relative w-full">
                      <input
                        name="password"
                        className="contact-form-input dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white"
                        id="password"
                        type={showPassword.password ? 'text' : 'password'}
                        required
                        onChange={(e) => {
                          setData({
                            ...data,
                            password: {
                              value: e.target.value,
                              error: validatePassword(e.target.value)
                                ? ''
                                : 'Password should be minimum of 8 characters',
                            },

                          });
                        }}
                        inputValue={data.password}
                      />
                      <span className="toggle-btn" onClick={() =>
                        setShowPassword({
                          ...showPassword,
                          password: !showPassword.password,
                        })
                      }>
                        {showPassword.password ? <Image src={eyeclose} alt="show" width={50} height={30} /> : <Image src={eyefill} width={50} height={30} alt="close" />}
                      </span>
                 
                    </div>
                    <div className=" text-left w-full text-red  ">{data.password.error}</div>
                  </div>

                  <div className="mb-4 w-1/2">
                    <label className="mb-1 flex items-center space-x-2 dark:text-jacarta-200 text-sm text-left uppercase">
                      Re-enter Password<span className="text-red">*</span>
                    </label>
                    <div className=" relative w-full">

                      <input
                        name="reEnter"
                        className="contact-form-input dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white"
                        id="reEnter"
                        type={showPassword.confirmPassword ? 'text' : 'password'}
                        required
                        onChange={(e) => {
                          setData({
                            ...data,
                            confirmPassword: {
                              value: e.target.value,
                              error:
                                data.password.value === e.target.value
                                  ? ''
                                  : 'Password not match',
                            },
                          });
                        }}
                        inputValue={data.confirmPassword}

                      />
                      <span className="toggle-btn" onClick={() =>
                        setShowPassword({
                          ...showPassword,
                          confirmPassword: !showPassword.confirmPassword,
                        })
                      }>
                        {showPassword.confirmPassword ? <Image src={eyeclose} alt="show" width={50} height={30} /> : <Image src={eyefill} width={50} height={30} alt="close" />}
                      </span>
                    </div>
                    <div className=" text-left w-full text-red  ">{data.confirmPassword.error}</div>
                  </div>
                </div>
                <div className="mb-4 flex items-center space-x-2">
                  <input
                    type="checkbox"
                    id="sign-up-term-form-consent-input"
                    name="termServices"
                    className="checked:bg-accent dark:bg-jacarta-600 text-accent border-jacarta-200 focus:ring-accent/20 dark:border-jacarta-500 h-5 w-5 self-start rounded focus:ring-offset-0 cursor-pointer"
                    onChange={(e) => {
                      setData({
                        ...data,
                        termsAndConditions: {
                          value: e.target.checked,
                          error: e.target.checked
                            ? ''
                            : 'Please select terms and conditions',
                        },
                      });
                    }}
                  />
                  <label className="dark:text-jacarta-200 text-sm text-left">
                    I&apos;ve read and agree after with the{" "}
                    <Link href="/terms-of-service" className="text-accent">
                      {" "}
                      Terms of Service{" "}
                    </Link>
                    and
                    <Link href="/privacy-policy" className="text-accent">
                      {" "}
                      Privacy Policy
                    </Link>
                    .
                  </label>
                  <div className=" text-left w-full text-red  ">{data.termsAndConditions.error}</div>
                </div>{" "}
                <div className="mb-4 flex items-center space-x-2">
                  <input
                    type="checkbox"
                    id="sign-up-mailing-form-consent-input"
                    name="optIn"
                    className="checked:bg-accent dark:bg-jacarta-600 text-accent border-jacarta-200 focus:ring-accent/20 dark:border-jacarta-500 h-5 w-5 self-start rounded focus:ring-offset-0 cursor-pointer"
                  />
                  <label className="dark:text-jacarta-200 text-sm">
                    Never miss a thing, join our mailing list.
                  </label>
                </div>
                <div className=" flex items-center space-x-2">
                  <p className="dark:text-jacarta-300 mb-10 text-lg leading-normal"></p>
                </div>
                <button onClick={handleOpen} className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 dark:hover:bg-accent hover:bg-accent font-semibold mb-4 flex w-full items-center justify-center rounded-full border-2 bg-white py-4 px-8 text-center transition-all hover:border-transparent hover:text-white dark:text-white dark:hover:border-transparent uppercase">
                  SIGN UP
                </button>
                <BasicModal body={<AgeVarify />} open={open} handleClose={handleClose} onRegistrationHandler={onRegistrationHandler}></BasicModal>


                <LoginWithGoogle method={'Sign Up'} />
              </form>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- end login --> */}
    </div>
  );
};

export default SignUp;
